import { _check_private_redeclaration } from "./_check_private_redeclaration.js";

export function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
export { _class_private_field_init as _ };
